/*
 * ParticipantListFrame.jsx 30.01.18
 *
 * (c) 2018 ergovia GmbH
 */

import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import PeopleIcon from '@material-ui/icons/People';
import Table from '@material-ui/core/Table';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ParticipantListHead from './ParticipantListHead';

import ParticipantListBodyContainer from '../../containers/participants/ParticipantListBodyContainer';

const styles = theme => ({
    toolbar: {
        textTransform: 'uppercase',
        color: theme.palette.text.primary,
        width: '190px',
        margin: '0 auto',
        padding: 0
    },
    peopleIcon: {
        margin: '-2px 9px -2px 0px'
    },

    tableContainer: {
        height: '80vh',
        overflowY: 'auto',
        '@media (max-height: 885px)': {
            height: '76vh'
        },
        '@media (max-height: 805px)': {
            height: '74vh'
        },
        '@media (max-height: 700px)': {
            height: '72vh'
        },
        '@media (max-height: 600px)': {
            height: '70vh'
        },
        '@media (max-height: 520px)': {
            height: '68vh'
        }
    },
    paper: {
        background: 'linear-gradient(135deg, #3f3f4e 0%,#4b4b5d 100%)',
        margin: '0 auto',
        width: '2000px',
        [theme.breakpoints.down(2000)]: {
            width: '1800px'
        },
        [theme.breakpoints.down(1850)]: {
            width: '1600px'
        },
        [theme.breakpoints.down(1650)]: {
            width: '1400px'
        },
        [theme.breakpoints.down(1450)]: {
            width: '1200px'
        },
        [theme.breakpoints.down(1250)]: {
            width: '1000px'
        },
        [theme.breakpoints.down(1050)]: {
            width: '800px'
        },
        [theme.breakpoints.down(850)]: {
            width: '600px'
        },
        [theme.breakpoints.down(650)]: {
            width: '400px'
        }
    }
});


/**
 * Stellt die Komplette Teilnehmerliste dar - mit Sortierheader, Zeitraumauswahl und pi-pa-po
 */
class ParticipantListFrame extends React.Component {

    render() {

        const {classes, sort} = this.props;

        return (
            <Paper className={classes.paper} elevation={2}>
                <Toolbar className={classes.toolbar}>
                    <PeopleIcon className={classes.peopleIcon}/>
                    <Typography variant="title">Teilnehmerliste</Typography>
                </Toolbar>

                <div className={classes.tableContainer}>
                    <Table>
                        <ParticipantListHead onSortChange={this.props.onSortChange} sort={sort} />
                        <ParticipantListBodyContainer />
                    </Table>
                </div>
            </Paper>
        );
    }
}

export default withStyles(styles)(ParticipantListFrame);



// WEBPACK FOOTER //
// ./src/de/ergovia/components/participants/ParticipantListFrame.jsx